import { Button, Popconfirm, Spin, Tooltip } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import React, { FC, Fragment, useEffect, useState } from "react";

import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

//IMAGES
import EnglishIcon from "assets/images/students/englishIcon.svg";
import FrenchIcon from "assets/images/students/frenchIcon.svg";
import StartIcon from "assets/images/students/teacherStart.svg";
import MessageIcon from "../../../../assets/images/app/message_icon.svg";
import TEACHER from "../../../../assets/images/teacher/teacher.svg";

//!STYLES
import { FLAGS, removeDuplicates, StatusCode } from "common/enums";
import { useDispatch, useSelector } from "react-redux";
import s from "../../../student/searchTeacher/components/assets/cardTeacher.module.css";

import * as appRoutes from "config/routes.config";

import { setIdTeacher, setSeeAvis, setUserConnect } from "store/auth/authSlice";
import { openPaiementDrawer } from "store/chat/mainSlice";
import { handleClearTopicStrings, handleClearTopicStringsLength } from "utils/formats";

import CertificationBadge from "components/certificationBadge";
import IconCourse from "screens/student/searchTeacher/components/iconCourse";
import {
  setChatReceiverId,
  setSelectUserChat,
  toggleAppChat
} from "store/AppChat/appChat";
import { useFindRoomMutation } from "store/services/chat";

interface CardAdsTeacher {
  ad: any;
  PlanningIsVisble?: boolean;
  isInstaProf?: boolean;
  instaProfData?: any;
  infoTeacherAcceptedReservation?: any;
  currentProfAccepted?: any;
  setCurrentProfAccepted?: any;
  isBtnInstaProf: boolean;
  resetDrawerInstaProf?: () => void;
  handleStudentAcceptTeacher?: any;
  showDrawerSearchInstaProf: () => void;
  handleDisplayTeacher: (id: string) => void;
  onShowDrawerCalendarProf: () => void;
  handleOpenDrwerProfileTeacher: () => void;
  setIsBtnInstaProf: React.Dispatch<React.SetStateAction<boolean>>;
  teacherAdded?: boolean;
}

const CardAdsTeacher: FC<CardAdsTeacher> = ({
  ad,
  PlanningIsVisble = true,
  isInstaProf,
  handleStudentAcceptTeacher,
  setCurrentProfAccepted,
  onShowDrawerCalendarProf,
  setIsBtnInstaProf,
  handleDisplayTeacher,
  handleOpenDrwerProfileTeacher,
  showDrawerSearchInstaProf,
  teacherAdded,
}) => {
  //!HOOKS
  const { user, isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [findRoom, { isSuccess }] = useFindRoomMutation();

  const closeDrawerPaiement = () => {
    dispatch(openPaiementDrawer());
  };

  const day = new Date();

  const handleDisplayTeacherMSG = (idTeacher: string) => {
    const finalData = {
      actor1: user?._id,
      actor2: idTeacher,
      flag: FLAGS.SINGLE_FLAG,
      type: "",
      instaprof: "",
    };

    findRoom(finalData);
    dispatch(setChatReceiverId(idTeacher));
  };

  ///Teachers
  const [isAdded, setIsAdded] = useState(teacherAdded ? true : false);
  const [loading, setLoading] = useState<boolean>(false);

  const setTeacher = async (idTeacher: string) => {
    setLoading(true);
    if (!isAdded) {
      try {
        const res = await AUTH_SERVICES.suggestTeacher(user?._id, idTeacher);
        if (res?.statusCode === StatusCode.CREATED) {
          setIsAdded(true);
        }
      }
      catch (error) { }
      finally {
        setLoading(false);
      }
    }
    else {
      try {
        const res = await AUTH_SERVICES.cancelSuggestTeacher(user?._id, idTeacher);
        if (res?.statusCode === StatusCode.CREATED) {
          setIsAdded(false);
        }
      }
      catch (error) { }
      finally {
        setLoading(false);
      }
    }
  }

  const handleProfileClick = () => {
    if (isLoggedIn) {
      dispatch(setIdTeacher(ad?._id));
      const profileUrl = `${appRoutes.PROFILETEACHER}/${ad?.teacher?._id}/${ad?.teacher?.firstname ? ad?.teacher?.firstname : "nom"}.${ad?.teacher?.lastname ? ad?.teacher?.lastname : "complet"}`;
      window.open(profileUrl, "_blank");
    } else {
      dispatch(setUserConnect(true));
    }
  }

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccess]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  return (
    <React.Fragment>
      <div className={`${s.card} ${!isInstaProf && `square`} `}>
        <div className={s.avatarNameBox} onClick={handleProfileClick}>
          <div className={s.avatarBox}><img src={ad?.teacher?.profile || TEACHER} height={isMobile ? 40 : 70} style={{ borderRadius: "50%" }} /></div>
          <div className={s.nameRateBox}>
            <Tooltip
              title={
                <span style={{ textTransform: "capitalize" }}>
                  {ad?.teacher?.firstname + " " + ad?.teacher?.lastname ||
                    "-"}
                </span>
              }
            >
              <div className={s.nameBox}>
                {ad?.teacher?.firstname?.split(" ")[0] || "-"}{" "}
                {ad?.teacher?.lastname?.split(" ")[0] || "-"}
                {ad?.teacher?.certified && <CertificationBadge />}
              </div>
            </Tooltip>

            <span style={{ textTransform: "uppercase", lineHeight: isMobile ? "10px" : "14px" }}>
              {ad?.teacher?.points > 0 &&
                ad?.teacher?.points <= 1000 &&
                "C'est mon ami"}
              {ad?.teacher?.points > 1000 &&
                ad?.teacher?.points <= 5000 &&
                "C'est mon grand ami"}
              {ad?.teacher?.points > 5000 &&
                ad?.teacher?.points <= 10000 &&
                "C'est mon vieil ami"}
              {ad?.teacher?.points > 10000 && "Tu es mon meilleur ami"}
            </span>

            <div className={s.rate} style={{ lineHeight: isMobile ? "15px" : "20px" }} onClick={() => {
              dispatch(setSeeAvis(true));
              handleProfileClick();
            }}>
              <span className={s.rateNumber}>
                {ad?.teacher?.rate && ad?.teacher?.rate !== 0 && Number(ad?.teacher?.rate).toFixed(2)}
                {ad?.teacher?.rate && ad?.teacher?.rate !== 0 && <img src={StartIcon} style={{ position: "relative", top: "-2px", marginLeft: "5px", marginRight: "5px" }} />}
                {ad?.teacher?.rateNum && ad?.teacher?.rateNum !== 0 && `(${ad?.teacher?.rateNum || 0} avis)`}
              </span>
            </div>

            <div style={{ color: "#707070", lineHeight: "10px" }}>
              {!isInstaProf && (
                <>
                  <span>
                    Je parle
                  </span>{" "}
                  {ad?.language?.includes("en") && (
                    <>
                      <img src={EnglishIcon} alt="" />{" "}
                    </>
                  )}
                  {ad?.language?.includes("fr") && (
                    <img src={FrenchIcon} alt="" />
                  )}
                </>
              )}

              {isInstaProf && (
                <Fragment>
                  <span>
                    Je parle
                  </span>{" "}
                  {ad?.teacher?.langues?.includes("en") && (
                    <>
                      <img src={EnglishIcon} alt="" />{" "}
                    </>
                  )}
                  {ad?.teacher?.langues?.includes("fr") && (
                    <img src={FrenchIcon} alt="" />
                  )}
                </Fragment>
              )}
            </div>
          </div>
        </div>
        <div className={isInstaProf ? s.__descriptionInsta : s.__description}>
          <Latex>
            {ad?.teacher?.career
              ? isInstaProf ? ad?.teacher?.career?.replace(/<\/?strong>/g, '').substring(0, 70)?.concat("...") : ad?.teacher?.career?.replace(/<\/?strong>/g, '').substring(0, 300)?.concat("...")
              : "Aucune description disponible"}
          </Latex>
        </div>
        <div className={isInstaProf ? s.matiersInsta : s.matiers}>
          {handleClearTopicStrings(ad?.teacher?.matieres)?.slice(0, isMobile ? 3 : 6).map((item: string) =>
            item ? (
              <div className={s.course} key={item}>
                <IconCourse course={item} />
                <span>
                  {item.includes("-")
                    ? item.split("-")[0]
                    : item === "Anglais"
                      ? "Anglais"
                      : item === "Mathématiques"
                        ? "Maths"
                        : item}
                </span>
              </div>
            ) : null
          )} {isMobile && handleClearTopicStringsLength(ad?.teacher?.matieres) > 3 && "..."}
        </div>
        <div className={isInstaProf ? s.levelGroupInsta : s.levelGroup}>
          {ad?.teacher?.groupLevels?.length > 0 ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
            {removeDuplicates(ad?.teacher?.groupLevels)?.slice(0, isMobile ? 3 : 6).map((level: any, index: number) => {
              return (
                level?.price !== "" && <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                  <div className="teacherLevelBox" key={index}>{level?.levelGroup}</div>
                </div>
              );
            })} {isMobile && ad?.teacher?.groupLevels?.length > 3 && "..."}
          </div> : <span>Non renseigné</span>}
        </div>

        {/*  <div className={s.tarif}>
          <span>Mes cours à partir de</span>{" "}
          {ad.minPrice}€/séance
        </div> */}

        <div className={s.rowButtons}>
          <Popconfirm
            title={isAdded ? "Souhaitez-vous retirer ce professeur de votre liste de favoris ?" : "Souhaitez-vous ajouter ce professeur à votre liste de favoris ?"}
            onConfirm={async () => { setTeacher(ad?.teacher?._id) }}
            onCancel={() => { }}
            okText="Oui"
            cancelText="Non"
          >
            {!loading && <Button onClick={() => { }} className={isAdded ? s.newInstaButton : s.newPlanningButton}>
              {isAdded ? "Retirer de ma liste" : "Ajouter à ma liste"}
            </Button>}
            <Spin spinning={loading} size="large" />
          </Popconfirm>

          <Button
            onClick={() => { handleDisplayTeacherMSG(ad?.teacher?._id) }}
            className={s.newMessageButton}
          >
            <img src={MessageIcon} height={isMobile ? 12 : 14} />
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardAdsTeacher;
